import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import HasanImage from '../assets/images/hasan.jpg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="w-60 h-60 rounded-full overflow-hidden">
          <img
            src={HasanImage}
            alt="Avatar"
            className="w-full h-full object-cover object-center"
          />
        </div>

        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/iamsayyadhasan" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/hasan07/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            <a href="https://github.com/Hasan-Abaris" target="_blank" rel="noreferrer"><GitHubIcon /></a>

          </div>
          <h1>Sayyad Hasan Shahzad</h1>
          <p>Full Stack Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/iamsayyadhasan" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/hasan07/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            <a href="https://github.com/Hasan-Abaris" target="_blank" rel="noreferrer"><GitHubIcon /></a>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;